import { Action, Reducer } from "redux";
import { AppThunkAction, remoteActions } from ".";

export const DISTANCE_CHANGED = "DISTANCE_CHANGED";

export interface DistanceValue {
  value: string;
  title: string;
}

export interface DistanceState {
  showMileageTextForTaxi?: boolean;
  mileageTextTaxi?: string;
  title?: string;
  help?: { title?: string; description?: string };
  label: { id?: string; title?: string };
  selected: string;
  values: DistanceValue[];
}

// for dev. purposes
const defaults = {
  // localize;
  // title: "Räkna ut ditt pris",
  selected: "1",
  help: {
    title: "Hur långt kör du per år?",
    description: "Välj det milintervall som motsvarar hur många mil du kör på ett år. Priset på försäkringen påverkas av hur långt du kör.",
  },
  label: {
    id: "2",
    title: "Hur många mil kör du med bilen per år?",
  },
  values: [
    {
      value: "1",
      title: "0 - 1000 mil",
    },
    {
      value: "2",
      title: "1001 - 1500 mil",
    },
  ],
};

type ValidAction = {
  type: typeof DISTANCE_CHANGED;
  payload: { value: string };
};

export const reducer: Reducer<DistanceState> = (state: DistanceState = defaults, input: Action): DistanceState => {
  const action = input as ValidAction;

  switch (action?.type) {
    case DISTANCE_CHANGED:
      return { ...state, selected: action.payload.value };

    default:
      return state;
  }
};

export const actions = {
  distanceChanged:
    (value: unknown): AppThunkAction<ValidAction | AppThunkAction<{}>> =>
      dispatch => {
        dispatch({
          type: DISTANCE_CHANGED,
          payload: { value: value as string },
        });

        dispatch(remoteActions.requestPriceData());
      },
};
